import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalWrapperComponent } from '../../../../UI-Lib/Modal-Wrapper/modalWrapper.component';
import { SelectComponent } from '../../../../UI-Lib/Select/select.component';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IWeissmanModalComponent } from '../../../../Compliance/WeissmanModalService';
import { ContractTerm } from '../../../../Common/Contracts-Invoices/contract-invoices.model';
import { ContractsInvoicesService } from '../../../../Common/Contracts-Invoices/contract-invoices.service';
import { FormsModule } from '@angular/forms';
import { YearPickerMixin } from '../../../../UI-Lib/Mixins';

export interface AddTermYearModalParams {
    companyId: number;
    selectedYear: number;
    services: { id: number; name: string; fullDisplayName?: string }[];
    allData: {
        currentContractTerms: ContractTerm[];
    };
    currentContractTerms: ContractTerm[];
}

@Component({
    selector: 'add-term-year',
    templateUrl: 'addTermYear.component.html',
    imports: [CommonModule, FormsModule, ModalWrapperComponent, SelectComponent],
})
export class AddTermYearComponent
    extends YearPickerMixin()
    implements OnInit, IWeissmanModalComponent<AddTermYearModalParams, number>
{
    constructor(
        private readonly _modalRef: BsModalRef,
        private readonly _contractsInvoicesService: ContractsInvoicesService,
    ) {
        super();
    }

    params: AddTermYearModalParams;
    result: number;

    addingYear: boolean;
    showFeeEscalator: boolean;
    rollForwardSiteOverrides: boolean;
    yearToAdd: number;
    yearsToAdd: { year: number; disabled: boolean }[];
    allData;

    ngOnInit(): void {
        this.allData = this.params.allData;

        this.showFeeEscalator = this.allData.feeEscalator !== null && this.allData.escalatorServiceTypes.length > 0;
        this.yearsToAdd = this.taxYears.map((year: number) => {
            return {
                year: year,
                disabled: this.params.currentContractTerms.some((x) => x.taxYear === year),
            };
        });

        const lastDisabledYearIndex: number = [...this.yearsToAdd]
            .reverse()
            .findIndex((year) => year.disabled === true);
        const actualLastDisabledYearIndex =
            lastDisabledYearIndex >= 0 ? this.yearsToAdd.length - 1 - lastDisabledYearIndex : -1;

        if (this.yearsToAdd[actualLastDisabledYearIndex - 1]) {
            this.yearToAdd = this.yearsToAdd[actualLastDisabledYearIndex - 1].year;
        } else {
            this.yearToAdd = this.yearsToAdd.reduce((maxYear, { year, disabled }) => {
                if (disabled) {
                    return maxYear;
                }
                return year > maxYear ? year : maxYear;
            }, 0);
        }
    }

    cancel(): void {
        this._modalRef.hide();
    }

    async save(): Promise<void> {
        this.addingYear = true;
        try {
            const newYearData = await this._contractsInvoicesService.rollForwardYear(
                this.params.companyId,
                this.params.selectedYear,
                this.yearToAdd,
                this.rollForwardSiteOverrides,
            );

            const mappedExisting = new Map(
                this.allData.currentContractTerms.map((t) => [t.contractTermDetailId, t as ContractTerm]),
            );
            for (const term of newYearData) {
                if (!mappedExisting.has(term.contractTermDetailId)) {
                    this.allData.currentContractTerms.push(term);
                }
            }

            this.result = this.yearToAdd;

            this._modalRef.hide();
        } finally {
            this.addingYear = false;
        }
    }

    getContractServiceTypename(serviceTypeId: number): string {
        return this.params.services.filter((s) => s.id == serviceTypeId).map((t) => t.fullDisplayName || t.name)[0];
    }
}
